// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__1xoxe","title":"ClientReferral_title__23Uzd","itemText":"ClientReferral_itemText__2kudL"};